import React from "react";
import { Button, Table, Typography } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { type UnassignedClient } from "./hooks/useUnassignedClients";

interface UnassignedClientsTableProps {
  clients: UnassignedClient[];
  isLoading: boolean;
}

export const UnassignedClientsTable = ({ clients, isLoading }: UnassignedClientsTableProps): React.ReactElement => {
  const { t } = useTranslation("trainees");
  const navigate = useNavigate();

  return (
    <Table<UnassignedClient>
      dataSource={clients}
      rowKey="id"
      size="middle"
      scroll={{ x: true }}
      pagination={false}
      loading={isLoading}
      locale={{ emptyText: t("emptyState") }}
    >
      <Table.Column<UnassignedClient>
        title={t("tableHeader.index")}
        width={50}
        key="index"
        render={(_value, _row, i) => i + 1}
      />
      <Table.Column<UnassignedClient>
        title={t("tableHeader.name")}
        dataIndex="name"
        key="name"
        render={(_value, row) => (
          <Button type="link" className="px-0" onClick={() => navigate(`/trainee/details/${row.id}`)}>
            {row.firstName} {row.lastName}
          </Button>
        )}
      />
      <Table.Column<UnassignedClient>
        title={t("tableHeader.email")}
        dataIndex="email"
        key="email"
        ellipsis
        render={(email: string) => (
          <Typography.Link href={`mailto:${email}`} target="_blank" copyable>
            {email}
          </Typography.Link>
        )}
      />
      <Table.Column<UnassignedClient>
        title={t("tableHeader.connectedProduct")}
        dataIndex="productClient"
        key="productClient"
        render={(productClient: UnassignedClient["productClient"]) => productClient?.product?.name ?? "-"}
      />
      <Table.Column<UnassignedClient>
        title={t("tableHeader.createdAt")}
        dataIndex="createdAt"
        key="createdAt"
        sorter={(a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf()}
        render={(createdAt: string) => dayjs(createdAt).format("DD.MM.YYYY")}
      />
    </Table>
  );
};
